"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesheet = void 0;
const theme_1 = require("@amzn/stencil-react-native-components/theme");
exports.stylesheet = (0, theme_1.createStencilStyle)(() => ({
    container: {
        position: 'relative',
        width: '100%',
        height: 8,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 8,
        backgroundColor: '#ffffff'
    },
    segmentWrapper: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        borderRadius: 8
    },
    threshold: {
        width: 2,
        height: 10
    },
    thresholdOutline: {
        position: 'absolute',
        backgroundColor: '#ffffff',
        padding: 2,
        top: -4
    },
    positive: {
        backgroundColor: '#00a890',
        borderColor: '#195f57'
    },
    warning: {
        backgroundColor: '#ca8700',
        borderColor: '#8E5D00'
    },
    negative: {
        backgroundColor: '#f4685e',
        borderColor: '#9a1818'
    },
    neutral: {
        backgroundColor: '#8b96a3',
        borderColor: '#394451'
    },
    loading: {
        backgroundColor: '#379aec',
        borderColor: '#1659a9'
    }
}));
//# sourceMappingURL=data:application/json;base64,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